import type { RegionsTranslation } from './types'

/**
 * Arabic translations for Regions domain
 */
export const regionsTranslationAr: RegionsTranslation = {
  // Page/Section level
  title: 'المناطق',
  subtitle: 'إدارة المناطق الجغرافية وتعيينات المصانع',

  // Actions
  addRegion: 'إضافة منطقة',
  editRegion: 'تعديل المنطقة',
  deleteRegion: 'حذف المنطقة',

  // Drawer Headers
  addRegionDescription: 'أدخل التفاصيل لإنشاء منطقة جديدة',
  editRegionDescription: 'قم بتحديث تفاصيل المنطقة أدناه',
  viewRegionDescription: 'عرض معلومات المنطقة والتعيينات',

  // Search and states
  searchPlaceholder: 'البحث في المناطق...',
  noRegions: 'لا توجد مناطق',
  noRegionsDescription:
    'لم يتم تكوين أي مناطق حتى الآن. أضف منطقتك الأولى لبدء إدارة المناطق الجغرافية.',
  addFirst: 'أضف منطقتك الأولى',

  // Form fields
  code: 'رمز المنطقة',
  codePlaceholder: 'مثال: وسطى، شرقية',
  name: 'اسم المنطقة',
  namePlaceholder: 'مثال: المنطقة الوسطى',
  description: 'الوصف',
  descriptionPlaceholder: 'أدخل وصف المنطقة (اختياري)',
  country: 'الدولة',
  selectCountry: 'اختر الدولة',
  factories: 'المصانع المعينة',
  selectFactories: 'اختر المصانع للتعيين',
  noFactoriesSelected: 'لم يتم تعيين مصانع',
  status: 'الحالة',

  // Status values
  active: 'نشط',
  inactive: 'غير نشط',
  all: 'الكل',

  // Stats
  totalRegions: 'إجمالي المناطق',
  activeRegions: 'نشط',
  inactiveRegions: 'غير نشط',
  factoriesCount: 'المصانع',
  citiesCount: 'المدن',

  // Table headers
  table: {
    code: 'الرمز',
    name: 'الاسم',
    country: 'الدولة',
    factories: 'المصانع',
    cities: 'المدن',
    status: 'الحالة',
    actions: 'الإجراءات',
  },

  // Card content
  card: {
    factories: 'المصانع',
    cities: 'المدن',
    noFactories: 'لم يتم تعيين مصانع',
    noCities: 'لا توجد مدن مرتبطة',
  },

  // Messages
  messages: {
    createSuccess: 'تم إنشاء المنطقة',
    createSuccessDescription: 'تم إنشاء المنطقة الجديدة بنجاح.',
    updateSuccess: 'تم تحديث المنطقة',
    updateSuccessDescription: 'تم تحديث المنطقة بنجاح.',
    deleteSuccess: 'تم حذف المنطقة',
    deleteSuccessDescription: 'تمت إزالة المنطقة.',
    deleteConfirm: 'حذف المنطقة',
    deleteConfirmDescription:
      'هل أنت متأكد من حذف هذه المنطقة؟ قد يؤثر ذلك على قيود عناوين العملاء.',
    loadError: 'فشل في تحميل المناطق. يرجى المحاولة مرة أخرى.',
  },

  // Validation
  validation: {
    codeRequired: 'رمز المنطقة مطلوب',
    codeInvalid: 'يجب أن يكون رمز المنطقة أبجديًا رقميًا وبأحرف كبيرة',
    nameRequired: 'اسم المنطقة مطلوب',
  },

  // Filter
  filter: {
    all: 'جميع الحالات',
    active: 'النشطة فقط',
    inactive: 'غير النشطة فقط',
    byCountry: 'تصفية حسب الدولة',
  },
}
